var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { ActivatedRoute } from "@angular/router";
import { TranslateService } from "app/translate/translate.service";
import { FilterFormService } from "app/views/filter_form/filter_form.service";
import { ChartParams } from "app/views/chart/chart.component";
import { EventsService } from "app/lib/EventsService";
import { BaseComponent } from "app/views/base.component";
import { PaymentStructureDetailComponent } from "./details/details.component";
import { ModalService } from "../../views/modal/base_modal.component";
import { PeriodService } from "../../views/period/period.service";
import { BillingService2 } from "../billing.service";
var PaymentStructureComponent = /** @class */ (function (_super) {
    __extends(PaymentStructureComponent, _super);
    function PaymentStructureComponent(modalService, activatedRoute, translate, filter, eventsService, periodService, service2) {
        var _this = _super.call(this, eventsService, service2, activatedRoute, filter, translate) || this;
        _this.modalService = modalService;
        _this.activatedRoute = activatedRoute;
        _this.translate = translate;
        _this.filter = filter;
        _this.eventsService = eventsService;
        _this.periodService = periodService;
        _this.service2 = service2;
        _this.addFilterParams = {
            userType: 'user',
            dateFilters: ['datePaid', 'dateCreated', 'dateSiteCreated'],
            period: 'month',
            isBilling: true,
        };
        _this.otherBorder = 100;
        _this.tariffVariants = new ChartParams({
            chartValue: 'absolute'
        });
        _this.tariffIds = new ChartParams({
            chartValue: 'absolute'
        });
        _this.paymenyType = new ChartParams({
            chartValue: 'absolute',
            type: 'bar',
            title: 'Распределение по способу оплаты (ручные оплаты)',
        });
        _this.currentTariffIds = new ChartParams({
            chartValue: 'absolute'
        });
        _this.intervals = new ChartParams();
        _this.disturbLoader = false;
        _this.disturbData = {
            userWithSiteCount: 0,
            userWithoutSiteCount: 0,
            stats: []
        };
        _this.periodService.period = _this.addFilterParams.period;
        return _this;
    }
    PaymentStructureComponent.prototype.getData = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getTariffVariantsChart()];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, this.getTariffIdsChart()];
                    case 2:
                        _a.sent();
                        return [4 /*yield*/, this.getPaymentTypeChart()];
                    case 3:
                        _a.sent();
                        return [4 /*yield*/, this.getIntervalsChart()];
                    case 4:
                        _a.sent();
                        return [4 /*yield*/, this.getCurrentTariffIdsChart()];
                    case 5:
                        _a.sent();
                        return [4 /*yield*/, this.getDisturbTable()];
                    case 6:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    PaymentStructureComponent.prototype.getPaymentTypeChart = function (chartValue) {
        if (chartValue === void 0) { chartValue = 'absolute'; }
        return __awaiter(this, void 0, void 0, function () {
            var fp, _a, charts, categories;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        fp = this.filter.getCopyFilterParams({
                            chartValue: chartValue,
                        });
                        this.paymenyType.showLoader();
                        this.tariffIds.options.chartValue = chartValue;
                        return [4 /*yield*/, this.service2.paymentStructure.chart(fp, 'type/charts').toPromise()];
                    case 1:
                        _a = _b.sent(), charts = _a.charts, categories = _a.categories;
                        this.paymenyType.data = charts;
                        this.paymenyType.setOptions({
                            groups: categories,
                            axis: {
                                y: {
                                    show: true,
                                    label: {
                                        text: chartValue === 'absolute' ? 'Оплаты' : '%',
                                        position: 'outer-middle'
                                    }
                                }
                            },
                        });
                        this.paymenyType.hideLoader();
                        return [2 /*return*/];
                }
            });
        });
    };
    PaymentStructureComponent.prototype.getTariffVariantsChart = function (chartValue) {
        if (chartValue === void 0) { chartValue = 'absolute'; }
        return __awaiter(this, void 0, void 0, function () {
            var fp, _a, charts, categories, tariffVariantList;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        fp = this.filter.getCopyFilterParams({
                            chartValue: chartValue,
                        });
                        this.tariffVariants.showLoader();
                        this.tariffVariants.options.chartValue = chartValue;
                        return [4 /*yield*/, this.service2.paymentStructure.chart(fp, 'tariff_variants').toPromise()];
                    case 1:
                        _a = _b.sent(), charts = _a.charts, categories = _a.categories, tariffVariantList = _a.tariffVariantList;
                        this.tariffVariants.data = charts;
                        this.tariffVariants.setOptions({
                            title: this.translate.__A('billing.payment_structure.tariff variants distribution'),
                            type: 'bar',
                            grid: {
                                y: {
                                    lines: [{ value: 0 }]
                                }
                            },
                            axis: {
                                x: {
                                    type: 'category',
                                    categories: categories,
                                    tick: {
                                        fit: true,
                                    }
                                }
                            },
                            groups: tariffVariantList
                        });
                        this.tariffVariants.hideLoader();
                        return [2 /*return*/];
                }
            });
        });
    };
    PaymentStructureComponent.prototype.getTariffIdsChart = function (chartValue) {
        if (chartValue === void 0) { chartValue = 'absolute'; }
        return __awaiter(this, void 0, void 0, function () {
            var fp, _a, charts, tariffIdList, categories;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        fp = this.filter.getCopyFilterParams({
                            chartValue: chartValue,
                        });
                        this.tariffIds.showLoader();
                        this.tariffIds.options.chartValue = chartValue;
                        return [4 /*yield*/, this.service2.paymentStructure.chart(fp, 'tariff_ids').toPromise()];
                    case 1:
                        _a = _b.sent(), charts = _a.charts, tariffIdList = _a.tariffIdList, categories = _a.categories;
                        this.tariffIds.data = charts;
                        this.tariffIds.setOptions({
                            title: this.translate.__A('billing.payment_structure.tariff ids distribution'),
                            type: 'bar',
                            grid: {
                                y: {
                                    lines: [{ value: 0 }]
                                }
                            },
                            axis: {
                                x: {
                                    type: 'category',
                                    categories: categories,
                                    tick: {
                                        culling: {
                                            max: 3
                                        }
                                    }
                                }
                            },
                            groups: tariffIdList
                        });
                        this.tariffIds.hideLoader();
                        return [2 /*return*/];
                }
            });
        });
    };
    PaymentStructureComponent.prototype.getIntervalsChart = function () {
        return __awaiter(this, void 0, void 0, function () {
            var fp, charts;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        fp = this.filter.getCopyFilterParams({
                            intervalOtherBorder: this.otherBorder,
                        });
                        this.intervals.showLoader();
                        return [4 /*yield*/, this.service2.paymentStructure.chart(fp, 'intervals').toPromise()];
                    case 1:
                        charts = (_a.sent()).charts;
                        this.intervals.data = charts;
                        this.intervals.setOptions({
                            title: this.translate.__A('billing.payment_structure.intervals'),
                            type: 'bar',
                            grid: {
                                y: {
                                    lines: [{ value: 0 }]
                                }
                            },
                            axis: {
                                x: {
                                    type: 'category',
                                    tick: {
                                        culling: {
                                            max: 3
                                        }
                                    }
                                }
                            }
                        });
                        this.intervals.hideLoader();
                        return [2 /*return*/];
                }
            });
        });
    };
    PaymentStructureComponent.prototype.getCurrentTariffIdsChart = function (chartValue) {
        if (chartValue === void 0) { chartValue = 'absolute'; }
        return __awaiter(this, void 0, void 0, function () {
            var fp, _a, charts, tariffIdList;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        fp = this.filter.getCopyFilterParams({
                            chartValue: chartValue,
                            intervalOtherBorder: this.otherBorder,
                        });
                        this.currentTariffIds.showLoader();
                        this.currentTariffIds.options.chartValue = chartValue;
                        return [4 /*yield*/, this.service2.paymentStructure.chart(fp, 'current_tariff_ids').toPromise()];
                    case 1:
                        _a = _b.sent(), charts = _a.charts, tariffIdList = _a.tariffIdList;
                        this.currentTariffIds.data = charts;
                        this.currentTariffIds.setOptions({
                            title: this.translate.__A('billing.payment_structure.current tariff ids distribution'),
                            type: 'bar',
                            grid: {
                                y: {
                                    lines: [{ value: 0 }]
                                }
                            },
                            axis: {
                                x: {
                                    type: 'category',
                                    categories: ['Total'],
                                    tick: {
                                        culling: {
                                            max: 3
                                        }
                                    }
                                }
                            },
                            groups: tariffIdList
                        });
                        this.currentTariffIds.hideLoader();
                        return [2 /*return*/];
                }
            });
        });
    };
    PaymentStructureComponent.prototype.getDisturbTable = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a, stats, userWithSiteCount, userWithoutSiteCount;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.disturbLoader = true;
                        return [4 /*yield*/, this.service2.paymentStructure.stats(this.filter.getFilterParams(), 'disturb').toPromise()];
                    case 1:
                        _a = _b.sent(), stats = _a.stats, userWithSiteCount = _a.userWithSiteCount, userWithoutSiteCount = _a.userWithoutSiteCount;
                        this.disturbData.userWithSiteCount = userWithSiteCount;
                        this.disturbData.userWithoutSiteCount = userWithoutSiteCount;
                        this.disturbData.stats = stats;
                        this.disturbLoader = false;
                        return [2 /*return*/];
                }
            });
        });
    };
    PaymentStructureComponent.prototype.changeChartValue = function (chart, value) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(chart == 'tariffVariants')) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.getTariffVariantsChart(value)];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2:
                        if (!(chart == 'tariffIds')) return [3 /*break*/, 4];
                        return [4 /*yield*/, this.getTariffIdsChart(value)];
                    case 3:
                        _a.sent();
                        _a.label = 4;
                    case 4:
                        if (!(chart == 'currentTariffIds')) return [3 /*break*/, 6];
                        return [4 /*yield*/, this.getCurrentTariffIdsChart(value)];
                    case 5:
                        _a.sent();
                        _a.label = 6;
                    case 6:
                        if (!(chart == 'paymenyType')) return [3 /*break*/, 8];
                        return [4 /*yield*/, this.getPaymentTypeChart(value)];
                    case 7:
                        _a.sent();
                        _a.label = 8;
                    case 8: return [2 /*return*/];
                }
            });
        });
    };
    PaymentStructureComponent.prototype.changeBorder = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this.getIntervalsChart();
                return [2 /*return*/];
            });
        });
    };
    PaymentStructureComponent.prototype.showDisturbDetails = function (stat) {
        return __awaiter(this, void 0, void 0, function () {
            var modalRef, stats;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        modalRef = this.modalService.open(PaymentStructureDetailComponent, {
                            title: "Site count: " + stat.siteCount + ", user count: " + stat.userCount
                        }, { size: 'hg' });
                        return [4 /*yield*/, this.service2.paymentStructure.detail(this.filter.getCopyFilterParams({
                                siteCount: stat.siteCount,
                            }), 'disturb/detail').toPromise()];
                    case 1:
                        stats = (_a.sent()).stats;
                        modalRef.componentInstance.stats = stats;
                        return [2 /*return*/];
                }
            });
        });
    };
    return PaymentStructureComponent;
}(BaseComponent));
export { PaymentStructureComponent };
